(function () {

  // ---------------------------------------------------------------------------
  // Collection-card sibling carousel
  // ---------------------------------------------------------------------------
  //
  // When a sibling swatch ([data-sibling-id]) is clicked on a product card:
  //   1. Prevent navigation.
  //   2. Wrap the original product's images in a scoped container so
  //      ProductBlock.setActiveImage()'s parentElement.children traversal only
  //      ever sees one product's images at a time.
  //   3. Inject the sibling's images from its <template data-sibling-images="id">
  //      into the same container (lazy, on first click for that sibling).
  //   4. Toggle which image set is visible.
  //   5. Rebuild block.images and call block.setActiveImage(0) so the existing
  //      prev/next buttons and dots continue to work.
  //   6. Rewrite .product-link / .quickbuy-toggle hrefs to the sibling URL.

  function wrapOriginalImages(block, originalProductId) {
    if (block.dataset.siblingInitialized) return;
    block.dataset.siblingInitialized = 'true';

    const imageParent = block.querySelector('.image-label-wrap > div');
    if (!imageParent) return;

    const originalImages = Array.from(
      imageParent.querySelectorAll(':scope > .product-block__image')
    );
    if (originalImages.length === 0) return;

    const originalSet = document.createElement('div');
    originalSet.dataset.imageOwner = originalProductId;
    originalSet.classList.add('sibling-image-set', 'sibling-image-set--active');

    imageParent.insertBefore(originalSet, originalImages[0]);
    originalImages.forEach((img) => originalSet.appendChild(img));
  }

  function syncDots(block, imageCount) {
    const dotsContainer = block.querySelector('.product-block__image-dots');
    if (!dotsContainer) return;

    dotsContainer.innerHTML = '';
    for (let i = 0; i < Math.min(imageCount, 3); i++) {
      const dot = document.createElement('div');
      dot.classList.add('product-block__image-dot');
      if (i === 0) dot.classList.add('product-block__image-dot--active');
      if (i === 2) dot.classList.add('product-block__image-dot--more');
      dotsContainer.appendChild(dot);
    }
  }

  function switchToSibling(block, siblingId, siblingUrl, swatchItem, swatchList) {
    const originalProductId = swatchList.dataset.originalProductId;
    const imageParent = block.querySelector('.image-label-wrap > div');
    if (!imageParent) return;

    // Lazy-wrap original images on first sibling interaction
    wrapOriginalImages(block, originalProductId);

    // Inject sibling images from <template> if not done yet
    let siblingSet = imageParent.querySelector(`[data-image-owner="${siblingId}"]`);
    if (!siblingSet) {
      const template = block.querySelector(`template[data-sibling-images="${siblingId}"]`);
      if (!template) return;

      siblingSet = document.createElement('div');
      siblingSet.dataset.imageOwner = siblingId;
      siblingSet.classList.add('sibling-image-set');
      siblingSet.hidden = true;
      siblingSet.appendChild(template.content.cloneNode(true));
      imageParent.appendChild(siblingSet);
    }

    // Switch the visible image set
    imageParent.querySelectorAll('.sibling-image-set').forEach((set) => {
      const isActive = set.dataset.imageOwner === siblingId;
      set.hidden = !isActive;
      set.classList.toggle('sibling-image-set--active', isActive);
    });

    // Rebuild block.images so ProductBlock's carousel methods target the right set.
    // block.images is a plain array property — reassigning is safe; methods read it at call time.
    if (block.images !== undefined) {
      block.images = Array.from(siblingSet.querySelectorAll('.product-block__image'));

      if (block.images.length > 0) {
        // Remove inactivated state from any freshly-injected images
        siblingSet.querySelectorAll('.product-block__image--inactivated').forEach((el) => {
          el.classList.remove('product-block__image--inactivated');
        });

        block.setActiveImage(0);
        syncDots(block, block.images.length);
      }
    }

    // Update all product links to point to the sibling
    block.querySelectorAll('.product-link, .quickbuy-toggle').forEach((el) => {
      el.href = siblingUrl;
    });

    // Toggle active swatch
    swatchList.querySelectorAll('.product-block-options__item').forEach((el) => {
      el.classList.toggle('is-active', el === swatchItem);
    });
  }

  document.addEventListener('click', (evt) => {
    const swatch = evt.target.closest('[data-sibling-id].product-block-options__item');
    if (!swatch) return;

    evt.preventDefault();

    const block = swatch.closest('product-block');
    if (!block) return;

    const swatchList = swatch.closest('[data-sibling-swatches]');
    if (!swatchList) return;

    switchToSibling(block, swatch.dataset.siblingId, swatch.href, swatch, swatchList);
  });


  // ---------------------------------------------------------------------------
  // Collection-card sibling swatches — single-label hover
  // ---------------------------------------------------------------------------
  //
  // Replaces CSS :hover label visibility (which can show multiple labels at
  // once) with JS-managed .label-peek. Only one label shows per card, and
  // all labels are cleared when the cursor leaves the swatch container.

  document.addEventListener('mouseover', function (evt) {
    const swatch = evt.target.closest('[data-sibling-swatches] .product-block-options__item');
    if (!swatch) return;
    const inner = swatch.closest('.product-block-options__inner');
    if (!inner) return;
    inner.querySelectorAll('.label-peek').forEach(function (el) {
      el.classList.remove('label-peek');
    });
    swatch.classList.add('label-peek');
  });

  document.addEventListener('mouseout', function (evt) {
    const inner = evt.target.closest('[data-sibling-swatches] .product-block-options__inner');
    if (!inner) return;
    if (!inner.contains(evt.relatedTarget)) {
      inner.querySelectorAll('.label-peek').forEach(function (el) {
        el.classList.remove('label-peek');
      });
    }
  });


  // ---------------------------------------------------------------------------
  // Collection-card +N expand button — click to permanently reveal all swatches
  // ---------------------------------------------------------------------------
  document.addEventListener('click', function (evt) {
    const btn = evt.target.closest('.product-block-options__more-label');
    if (!btn) return;
    const inner = btn.closest('.product-block-options__inner');
    if (!inner) return;
    inner.querySelectorAll('.product-block-options__item--truncated').forEach(function (item) {
      item.classList.remove('product-block-options__item--truncated');
    });
    btn.hidden = true;
  });


  // ---------------------------------------------------------------------------
  // PDP sibling swatches — hover label update
  // ---------------------------------------------------------------------------

  document.querySelectorAll('.related-swatches').forEach(function (container) {
    const colorLabel = container.parentElement.querySelector('.option-selector__label-value');
    if (!colorLabel) return;

    const defaultName = colorLabel.dataset.default ?? colorLabel.textContent;

    container.querySelectorAll('.related-swatch').forEach(function (link) {
      if (link.dataset.swatchInit) return;
      link.dataset.swatchInit = 'true';

      const nameSpan = link.querySelector('[data-color-name]');
      if (!nameSpan) return;
      const colorName = nameSpan.dataset.colorName;

      link.addEventListener('mouseenter', () => colorLabel.textContent = colorName);
      link.addEventListener('mouseleave', () => colorLabel.textContent = defaultName);
      link.addEventListener('focus', () => colorLabel.textContent = colorName);
      link.addEventListener('blur', () => colorLabel.textContent = defaultName);
    });
  });

})();
